import { Group } from '@mantine/core';
import * as React from 'react';
import { useAuth } from "../contexts/auth.context";
import InputField, { InputFieldTypes } from './input_field';

export default function RolesSelect({ refresh = false, onChange = null }){
    const { role, roles, onChangeRole } = useAuth();

    return role ? <Group style={{flex: 1}} mr="md" ml="md">
    <InputField
      type={InputFieldTypes.SELECT}
      options={roles.map(r => ({label: r.company.name, value: r._id}))}
      value={role?._id}
      name="roleId"
      clearable={false}
      onChange={({roleId}) => {
        onChange && onChange(roleId);
        onChangeRole(roleId, refresh)
      }}
    />
  </Group> : <div style={{flex: 1}}></div>
}